const LATIN_TO_CYRILLIC: Record<string, string> = {
  A: 'А', B: 'В', E: 'Е', K: 'К', M: 'М', H: 'Н', O: 'О', P: 'Р', C: 'С', T: 'Т', Y: 'У', X: 'Х',
};

/** Plate as the resident sees it: upper case, no spaces, Latin look-alikes as Cyrillic (spec §6.3). The server stores its own form. */
export function normalizePlate(input: string): string {
  return input
    .toUpperCase()
    .replace(/\s+/g, '')
    .replace(/[ABEKMHOPCTYX]/g, (ch) => LATIN_TO_CYRILLIC[ch]);
}

const LETTER = '[АВЕКМНОРСТУХ]';
const FULL_PLATE = [new RegExp(`^${LETTER}\\d{3}${LETTER}{2}\\d{2,3}$`), new RegExp(`^${LETTER}{2}\\d{3}\\d{2,3}$`)];

/**
 * A complete Russian plate with its region: private «А123ВС77» or taxi/route «АВ12377». The home screen orders
 * without a second look at a form, so a plate that is cut short gets a warning before the pass is created.
 */
export function isFullPlate(plate: string): boolean {
  const p = normalizePlate(plate);
  return FULL_PLATE.some((re) => re.test(p));
}

/** What each place of the GOST template «Б 999 ББ» takes: one of the 12 plate letters or a digit. */
export const PLATE_TEMPLATE = ['letter', 'digit', 'digit', 'digit', 'letter', 'letter'] as const;
const FITS = { letter: /^[АВЕКМНОРСТУХ]$/u, digit: /^\d$/ };

/**
 * Typed or pasted text laid into the template: every character goes to the next place only if it is of that
 * place's kind (Latin look-alikes count as Cyrillic), anything else is dropped. Digits after the sixth place
 * go to the region, up to three, so a pasted «т001тт 77» fills both fields.
 */
export function maskPlate(input: string): { plate: string; region: string } {
  let plate = '';
  let region = '';
  for (const ch of normalizePlate(input)) {
    if (plate.length < PLATE_TEMPLATE.length) {
      if (FITS[PLATE_TEMPLATE[plate.length]].test(ch)) plate += ch;
    } else if (/\d/.test(ch) && region.length < 3) {
      region += ch;
    }
  }
  return { plate, region };
}

/** The region field takes digits only, two or three of them. */
export function maskRegion(input: string): string {
  return input.replace(/\D/g, '').slice(0, 3);
}
